const _ = require('lib/underscore')
const Backbone = require('lib/backbone')
const RelatedModel = require('./related_model')
const RelatedList = require('./related_list')
const ProductList = require('./product_list')
const CreditCard = require('./credit_card')

const ACTIVE_PLAN_STATUSES = [
    'active',
    'cancel_pending',
    'delinquent',
    'trialing',
]

const INACTIVE_PLAN_STATUSES = [
    'canceled',
]

const PLAN_STATUSES = [].concat(ACTIVE_PLAN_STATUSES, INACTIVE_PLAN_STATUSES)

const PLAN_TYPES = [
    'plan',
    'domain',
]

const Purchases = ProductList.extend({
    id: 'purchases',
    comparator(a, b) {
        // sort by status, type, and date descending
        return (
            this.sortByStatus(a, b)
            || this.sortByType(a, b)
            || this.sortByPurchaseDate(a, b)
        )
    },
    sortByStatus(a, b) {
        const ai = this.getModelStatusIndex(a)
        const bi = this.getModelStatusIndex(b)
        return ai - bi
    },
    sortByType(a, b) {
        const ai = this.getModelTypeIndex(a)
        const bi = this.getModelTypeIndex(b)
        return ai - bi
    },
    getModelStatusIndex(model) {
        let index = PLAN_STATUSES.indexOf(model.get('status'))
        // sort invalid statuses last - shouldn't exist, but just in case
        if (index === -1) index = PLAN_STATUSES.length
        return index
    },
    getModelTypeIndex(model) {
        let index = PLAN_TYPES.indexOf(model.get('type'))
        // sort invalid types last - shouldn't exist, but just in case
        if (index === -1) index = PLAN_TYPES.length
        return index
    },
    sortByPurchaseDate(a, b) {
        return b.get('purchased_date') - a.get('purchased_date')
    },

})

const Store = RelatedModel.extend({

    id: 'store',

    defaults: {
        credit_card: {
            id: 'credit_card',
        },
        charges: [],
        purchases: [],
    },

    relations: [
        {
            type: Backbone.One,
            key: 'credit_card',
            relatedModel: CreditCard,
        },
        {
            type: Backbone.Many,
            key: 'charges',
            collectionType: RelatedList.extend({
                id: 'charges',
                comparator: 'date',
            }),
        },
        {
            type: Backbone.Many,
            key: 'purchases',
            collectionType: Purchases,
        },
    ],

    calculated_values: {

        plan() {
            // if they have an active plan return that
            const active_plan = this.get('active_plan')
            if (active_plan) return active_plan

            // they might have an inactive plan. return the first one
            // need to revisit if we have multiple plans
            return this.get('purchases').first()
        },

        active() {
            const plans = this.get('purchases').filter((item) => {
                return _.contains(ACTIVE_PLAN_STATUSES, item.get('status'))
            })
            return plans
        },

        active_plan() {
            // return the first active/cancel_pending/delinquent/trialing plan
            const plans = this.get('purchases').where({ type: 'plan' })
            return _.find(plans, (item) => {
                return _.contains(ACTIVE_PLAN_STATUSES, item.get('status'))
            })
        },

        active_plan_id() {
            // return the id of their active plan, or undefined
            const active_plan = this.get('active_plan')
            if (! active_plan) return

            return active_plan.get('id')
        },

        is_free_pro_user() {
            // if user has a non-stripe cust_id, they're a free pro user
            // e.g. MS promo code users
            const stripe_id_pattern = new RegExp('^cus_', 'i')
            const cust_id = this.get('cust_id')
            if (! cust_id) return false
            if (stripe_id_pattern.test(cust_id)) return false
            return true
        },

    },

})

module.exports = Store
